import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPrevious = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.3884 6.66663C8.18009 6.66663 6.18009 7.49163 4.63843 8.83329L3.06343 7.25829C2.53843 6.73329 1.63843 7.09996 1.63843 7.84163V12.5C1.63843 12.9583 2.01343 13.3333 2.47176 13.3333H7.13009C7.87176 13.3333 8.24676 12.4333 7.72176 11.9083L6.13009 10.3166C7.28843 9.34996 8.76343 8.74996 10.3968 8.74996C13.0301 8.74996 15.3051 10.2833 16.3884 12.5C16.6134 12.9666 17.1468 13.2 17.6384 13.0333C18.2301 12.8416 18.5301 12.1666 18.2634 11.6C16.8301 8.68329 13.8468 6.66663 10.3884 6.66663Z",
		fill: "currentColor"
	})
});
export default SvgPrevious;
